import { PartnerListPageState } from ".";

const displayColumn = [
  { label: "Chain Type", value: "chnTypeCd" },
  { label: "Partner", value: "ptnrId" },
  { label: "Partner Code", value: "pntrCd" },
];

export const PartnerListPageInitialState: PartnerListPageState = {
  searchDepartmentId: "",
  searchResult: {
    partnerList: [],
  },
  dipByRegionList: [],
  mergeMap: [],
  dipByRgnDropdown: [],
  searchField: {
    dipByRgn: "",
    cpntId: "",
    ptnrCd: "",
    ptnrName: "",
  },
  dataList: {
    inDefCommonFlagType: [],
  },
  fieldPath: {
    dipByRgn: "dipByRgn",
    cpntId: "cpntId",
    ptnrCd: "ptnrCd",
    ptnrName: "ptnrName",
  },
  isInitialized: false,
  displayColumn: displayColumn,
};
